<template>
  <component
    :is="buttonComponent"
    class="ds-button"
    :class="[colorClass, sizeClass, fullWidthClass, loadingClass, reducedPaddingsClass]"
    :data-test-id="dataTestId"
    :target="target"
    v-bind="componentLink"
    @click="$emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script>
import htmlProps from '../htmlProps.js';

export default {
  name: 'BaseButton',
  emits: ['click'],
  mixins: [htmlProps],
  props: {
    color: {
      type: String,
      validator(color) {
        return ['green', 'red', 'inverse', 'white', 'icon', 'text', 'text-red'].indexOf(color) !== -1;
      },
      default: 'green',
    },
    href: {
      type: String,
      default: '',
    },
    to: {
      type: [String, Object],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      validator(size) {
        return ['default', 'small', 'large'].indexOf(size) !== -1;
      },
      default: 'default',
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    reducedPaddings: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonComponent() {
      if (this.to) return 'router-link';
      if (this.href) return 'a';
      return 'button';
    },
    componentLink() {
      if (this.to) return { to: this.to };
      if (this.href) return { href: this.href };
      return {};
    },
    colorClass() {
      return {
        green: 'ds-button--green',
        red: 'ds-button--red',
        inverse: 'ds-button--inverse',
        icon: 'ds-button--icon',
        white: 'ds-button--white',
        text: 'ds-button--text',
        'text-red': 'ds-button--textRed',
      }[this.color];
    },
    sizeClass() {
      return {
        default: '',
        small: 'ds-button--small',
        large: 'ds-button--large',
      }[this.size];
    },
    fullWidthClass() {
      return this.isFullWidth ? 'ds-button--full-width' : '';
    },
    loadingClass() {
      return this.isLoading ? 'ds-button--is-loading' : '';
    },
    reducedPaddingsClass() {
      return this.reducedPaddings ? 'ds-button--reduced-paddings' : '';
    },
  },
};
</script>
